import styled, { css } from 'styled-components';
import { breakpoint } from '../theme/breakpoint';

export const AddMargin = styled.div`
  margin-bottom: ${({ $removeMarginBottom, theme }) =>
    $removeMarginBottom ? '0' : theme.spacing.large};
`;

export const Wrapper = styled.div`
  border-top: ${({ theme }) => `1px solid ${theme.palette.borderDark}`};
  background-color: ${({ theme }) => theme.palette.darkBackground};
  color: ${({ theme }) => theme.palette.white};
  text-align: center;
  ${({ $decorated, theme }) =>
    $decorated
      ? css`
          padding-bottom: ${theme.spacing.xlarge};
        `
      : css`
          padding: ${theme.spacing.medium} 0;
        `};
`;

export const CTAWrapper = styled(Wrapper)`
  border-top: ${({ theme }) => `2px solid ${theme.palette.white}`};
`;

export const Header = styled.h2`
  max-width: 635px;
  margin: 0 auto;
  margin-bottom: ${({ theme, $decorated }) => $decorated && theme.spacing.tiny};
  text-transform: ${({ $decorated }) => ($decorated ? 'uppercase' : 'none')};
`;

export const BodyText = styled.p`
  max-width: 635px;
  margin: 0 auto;
`;

export const BrushElement = styled.img`
  width: 170px;
  height: 96px;
  margin-top: ${({ theme }) => `-${theme.spacing.large}`};
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

export const CallToActionText = styled.p`
  margin-bottom: 0;
  text-transform: uppercase;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${breakpoint.tablet`
  flex-direction: row;
`}

  justify-content: center;
  align-items: center;
  max-width: 440px;
  width: 100%;
  margin: 0 auto;

  gap: ${({ theme }) => theme.spacing.standard};
  color: ${({ theme }) => theme.palette.white};
  padding: 0
    ${({ $padding, theme }) =>
      $padding === false ? 0 : theme.spacing.standard};

  ${({ theme }) =>
    css`
      padding: 0 ${theme.spacing.standard};

      ${breakpoint.tablet`
       padding: 0;
    `};
    `}

  > a {
    width: 100%;
    ${breakpoint.tablet`
      width: auto;
    `}
  }
`;
